import script from "./gamesearchPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./gamesearchPopup.vue?vue&type=script&lang=ts&setup=true"

import "./gamesearchPopup.vue?vue&type=style&index=0&id=526fe5fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526fe5fe"]])

export default __exports__